// Функция, определяющая величину объекта
Object.size = function (obj) {
  let size = 0, key;
  for (key in obj) {
    if (obj.hasOwnProperty(key)) {
      size++;
    }
  }
  return size;
};

Array.prototype.insert = function (index, item) {
  this.splice(index, 0, item);
};

window.isPrivacyChecked = function (form) {
  const checkbox = form && form.querySelector('input[name="privacy"]');
  if (!checkbox) {
    return true;
  }

  const wrap = checkbox.closest('.form-privacy');
  checkbox.setCustomValidity(
    checkbox.checked ? '' : 'Необходимо согласие на обработку персональных данных'
  );

  if (!checkbox.checked) {
    if (wrap) {
      wrap.classList.add('form-privacy--error');
    }
    checkbox.reportValidity();
    return false;
  }

  if (wrap) {
    wrap.classList.remove('form-privacy--error');
  }
  return true;
};

window.resetPrivacy = function (form) {
  const checkbox = form && form.querySelector('input[name="privacy"]');
  if (!checkbox) {
    return;
  }

  checkbox.checked = false;
  checkbox.setCustomValidity('');
  const wrap = checkbox.closest('.form-privacy');
  if (wrap) {
    wrap.classList.remove('form-privacy--error');
  }
};

document.addEventListener('change', (e) => {
  if (e.target.matches && e.target.matches('input[name="privacy"]')) {
    e.target.setCustomValidity('');
    const wrap = e.target.closest('.form-privacy');
    if (wrap && e.target.checked) {
      wrap.classList.remove('form-privacy--error');
    }
  }
});
